import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { ToastViewport,TooltipProvider } from '@/components/ui';
import { queryClient } from '@/lib/query-client';
import { router } from '@/router';

/** Стек провайдерів. Нове загортання додається сюди, не в main.tsx. */
export function App(): ReactNode {
	return (
		<QueryClientProvider client={queryClient}>
			{/* Підказки й повідомлення — наскрізні: доступні з будь-якого екрана. */}
			<TooltipProvider>
				<RouterProvider router={router} />
				<ToastViewport />
			</TooltipProvider>
		</QueryClientProvider>
	);
}
